<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_vii"></a>Contents</h2>
<p class="toc-entry"><a href="#/xhtml/frontmatter01">Preface</a></p>
<p class="para"> </p>
<p class="toc-entry"><a href="#/xhtml/chapter01">Setting Out</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter02">Agapanthus</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter03">Annuals</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter04">Arborvitae</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter05">Artichokes</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Bananas</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">The Bay Tree</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Berberis</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Biennials</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Boxwood</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Camellias</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Colchicum</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Corydalis</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Cyclamen</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter15" title="Link target outside of Sample">The Daffodil Meadow</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Forcing Branches</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter17" title="Link target outside of Sample">The Garden Trowel</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter18" title="Link target outside of Sample">Gentians</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter19" title="Link target outside of Sample">Hardiness</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter20" title="Link target outside of Sample">Hedges</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter21" title="Link target outside of Sample">Hellebores</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter22" title="Link target outside of Sample">Ilex</span></p>
<p class="toc-entry"><a id="page_viii"></a><span href="#/xhtml/chapter23" title="Link target outside of Sample">Leucojum</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter24" title="Link target outside of Sample">Lilacs</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter25" title="Link target outside of Sample">Magnolias</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter26" title="Link target outside of Sample">Native Groundcovers</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter27" title="Link target outside of Sample">Nerines</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter28" title="Link target outside of Sample">Pea Season</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter29" title="Link target outside of Sample">The Pergola Walk</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter30" title="Link target outside of Sample">Poppies</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter31" title="Link target outside of Sample">Pots</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter32" title="Link target outside of Sample">Primroses</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter33" title="Link target outside of Sample"><em>Prunus</em> ×‘Hally Jolivette’</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter34" title="Link target outside of Sample"><em>Prunus mume</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter35" title="Link target outside of Sample">Rampant Plants</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter36" title="Link target outside of Sample">The Rock Garden and Planted Walls</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter37" title="Link target outside of Sample">Roses</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter38" title="Link target outside of Sample">Sempervivums</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter39" title="Link target outside of Sample">Snowdrops</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter40" title="Link target outside of Sample"><em>Sorbus alnifolia</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter41" title="Link target outside of Sample">Stewartias</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter42" title="Link target outside of Sample">Summer-Blooming Bulbs</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter43" title="Link target outside of Sample">Tender Rhododendrons</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter44" title="Link target outside of Sample">Time</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter45" title="Link target outside of Sample">Vegetable Gardens</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter46" title="Link target outside of Sample">Violets</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter47" title="Link target outside of Sample">Willows</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter48" title="Link target outside of Sample">Wisteria</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter49" title="Link target outside of Sample"><em>Xanthorrhoea quadrangulata</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter50" title="Link target outside of Sample">The Future</span></p>
<p class="para"> </p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7428f1c3